<template>
  <div class="domain-item-outer" :style="'background-image:url(' + domain.bgUrl + ')'">
    <img :src="domain.iconUrl" class="domain-item-icon"/>
    <div class="domain-item-title">{{domain.title}}</div>
    <div class="domain-item-desp">{{domain.desp}}</div>
    <div class="domain-item-link">点击了解 ></div>
  </div>
</template>

<script>
  export default {
    name: 'DomainItem',
    props: {
      domain: Object
    }
  }
</script>

<style scoped>
  .domain-item-outer {
    position: relative;
    display: inline-block;
    width: 20.21vw;
    height: 35.57vw;
    background-repeat: no-repeat;
    background-size: cover;
    margin-right: 1.354vw;
    transition: all 0.3s;
  }

  .domain-item-outer:hover {
    transform: translate(0px, -30px);
    box-shadow: 0 0 30px #aaa;
    background-color: #1158E8;
    background-image: none !important;
  }

  .domain-item-icon {
    width: 6.771vw;
    height: 6.771vw;
    margin-top: 5.3125vw;
    margin-left: 6.719vw;
  }

  .domain-item-title {
    font-family: PingFangSC-Semibold;
    font-size: 2.083vw;
    color: #FFFFFF;
    text-align: center;
    line-height: 2.083vw;
    margin-top: 3.177vw;
  }

  .domain-item-desp {
    font-family: PingFangSC-Regular;
    font-size: 0.833vw;
    color: #FFFFFF;
    line-height: 1.5625vw;
    width: 15.208vw;
    margin: 2.083vw auto;
  }

  .domain-item-link {
    width: 8vw;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 0.833vw;
    color: #FFFFFF;
    line-height: 1.5625vw;
    position: absolute;
    left: 50%;
    margin-left: -4vw;
    bottom: 4.323vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/DomainItem.vue